import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import * as Yup from "yup";
import AlertComponent from "../components/AlertComponent";
import ModalComponent from "../components/ModalComponent";
import { deleteUser, editUser, editUserPlusDetail, postUser, postUserPlusDetail } from "../redux/action/userAction";
import { openForm } from "../redux/slice/userSlice";
import { Input, SelectInput, TextArea } from "../components/InputComponent";
import { getSitesList } from "../redux/action/sitesAction";
import { postUserDetail } from "../redux/action/userDetailAction";
import ButtonComponent from "../components/ButtonComponent";
import { getRoleList } from "../redux/action/roleAction";

const FormUser = ({ param }) => {
  const { dataUser, idUser, dataByIdUser, isOpenForm, state } = useSelector( (state) => state.user);
  const dispatch = useDispatch();
  const { dataSitesList } = useSelector( (state) => state.sites );
  const { dataRoleList } = useSelector( (state) => state.role );
  const [optionSites, setOptionSites] = useState([])
  const [optionRole, setOptionRole] = useState([])
  const [roleId, setRole] = useState('')
  const [siteId, setSite] = useState('')
  const [showPassword, setShowPassword] = useState(false);

  // console.log(dataRoleList)
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const initialValues = {
    username: '',
    password: '',
    roleId: '',
    firstName: '',
    lastName: '',
    phone: '',
    address: '',
    userId: '',
    sitesId: '',
  };

  const validationSchema = Yup.object().shape({
    username: Yup.string().required("Nama Pengguna Id is required!"),
    password: Yup.string().min(6, 'Kata sandi harus terdiri dari minimal 6 karakter')
    .required('Kata sandi wajib diisi'),
    // roleId: Yup.string().required("ID Role Name is required!"),
    firstName: Yup.string().required("Nama Depan is required!"),
    lastName: Yup.string().required("Nama Belakang Id is required!"),
    phone: Yup.string().required("No Telp Name is required!"),
    address: Yup.string().required("Alamat Name is required!"),
    // userId: Yup.string().required("Units Name is required!"),
    // sitesId: Yup.string().required("Units Name is required!"),
  });

  const resetOption = () =>{
    setRole('')
    setSite('')
  }

  const handleFormSubmit = async (values) => {
    // console.log(values)
    if (state === "add") {
      // console.log(param)
      param.bodyUser = values;
      // console.log(param.bodyUser);
      dispatch(postUserPlusDetail(param));
      resetOption()
    } else if (state === "edit") {
      param.bodyUser = values;
      param.id = idUser;
      dispatch(editUserPlusDetail(param));
      resetOption()
    } else {
    //   param.id = idUser;
    //   dispatch(deleteUser(param));
    }
  };

  const newSites = () => {
    // console.log(dataSupervisor)
    let arr = [{ name: '- PILIH SITES -', id: '' }]
    dataSitesList.map((row, index) => {
      arr.push({ name: row.siteName, id: row.siteId })
    })
    setOptionSites(arr)
    
  }
  useEffect(() => {
    newSites()
  }, [])
  useEffect(() => {
    if (dataSitesList.length > 0) {
      newSites()
    }
  }, [dataSitesList])

  const newRole = () => {
    // console.log(dataRoleList)
    let arr = [{ name: '- PILIH PERAN -', id: '' }]
    dataRoleList.map((row, index) => {
      arr.push({ name: row.name, id: row.id })
    })
    setOptionRole(arr)
  }
  useEffect(() => {
    newRole()
  }, [])
  useEffect(() => {
    if (dataRoleList.length > 0) {
      newRole()
    }
  }, [dataRoleList])

  useEffect(() => {
    dispatch(getSitesList(param));
    dispatch(getRoleList(param));
  }, []);

  return state === "delete" ? (
    <AlertComponent
      show={isOpenForm}
      close={() => dispatch(openForm({ open: false, state: "close" }))}
      action={() => handleFormSubmit()}
    />
  ) : (
    <ModalComponent
      title= "TAMBAH USER"
      show={isOpenForm}
      close={() => dispatch(openForm({ open: false, type: "close" }))}
      idForm="user-form"
    >
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit} id="user-form">
            <div className="row align-items-center" style={{ color: "white" }}>
              <div className="form-group row mb-3">
                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Nama Pengguna
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                  <Input
                    onChange={handleChange}
                    type="text"
                    name="username"
                    id="username"
                    className="form-control"
                    value={values.username}
                    validation={''}
                    props={{
                      onBlur: handleBlur,
                    }}
                  />
                  {touched.username && errors.username && (
                    <span style={{ color: "red" }}>{errors.username}</span>
                  )}
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Kata Sandi
                </label>
                <div className="col-sm-9" style={{ paddingBottom: "10px" }}>
                  <Input
                    onChange={handleChange}
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    id="password"
                    className="form-control"
                    value={values.password}
                    validation={{touched: touched.password, errors: errors.password}}
                    props={{
                      onBlur: handleBlur,
                      placeholder: 'Ex : Password (tidak boleh kurang dari 6 karakter)',
                    }}
                  />
                  {touched.password && errors.password && (
                    <span style={{ color: "red" }}>{errors.password}</span>
                  )}
                </div>
                <div className="col-sm-1" style={{ paddingBottom: "10px" }}>
                  <ButtonComponent type="button" onClick={togglePasswordVisibility} >
                    {showPassword ?  <i className="fas fa-eye" /> :  <i className="fas fa-eye-slash" />}
                  </ButtonComponent>
                </div>

                <label
                  htmlFor="staticEmail"
                  className="col-sm-2 col-form-label"
                >
                  Pilih Peran
                </label>
                <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                    <SelectInput
                      onChange={(e) => {
                        // console.log(e.target.value)
                        let event = { target: { name: 'roleId', value: e.target.value } }
                          setRole(e.target.value)
                          handleChange(event)
                      }}
                      name="roleId"
                      id="roleId"
                      value={roleId}
                      option={optionRole}
                      validation={''}
                    props={{
                      onBlur: handleBlur,
                      helperText: touched.roleId && errors.roleId,
                      error: Boolean(errors.roleId && touched.roleId),
                    }}
                    />
                    {touched.roleId && errors.roleId && (
                      <span>{errors.roleId}</span>
                    )}
                </div>
              </div>
            </div>
            <div className="row align-items-center" style={{ color: "white" }}>
                    <div className="form-group row mb-3">
                      <label
                        htmlFor="staticEmail"
                        className="col-sm-2 col-form-label"
                      >
                        Nama Depan
                      </label>
                      <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                        <Input
                          onChange={handleChange}
                          type="text"
                          name="firstName"
                          id="firstName"
                          className="form-control"
                          value={values.firstName}
                          validation={''}
                          props={{
                            onBlur: handleBlur,
                          }}
                        />
                        {touched.firstName && errors.firstName && (
                          <span style={{ color: "white" }}>{errors.firstName}</span>
                        )}
                      </div>

                      <label
                        htmlFor="staticEmail"
                        className="col-sm-2 col-form-label"
                      >
                        Nama Belakang
                      </label>
                      <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                        <Input
                          onChange={handleChange}
                          type="text"
                          name="lastName"
                          id="lastName"
                          className="form-control"
                          value={values.lastName}
                          validation={''}
                          props={{
                            onBlur: handleBlur,
                          }}
                        />
                        {touched.lastName && errors.lastName && (
                          <span style={{ color: "white" }}>{errors.lastName}</span>
                        )}
                      </div>

                      <label htmlFor="staticEmail" className="col-sm-2 col-form-label" >
                        Nomor Telephone
                      </label>
                      <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                        <Input
                          onChange={handleChange}
                          type="number"
                          name="phone"
                          id="phone"
                          className="form-control"
                          value={values.phone}
                          validation={''}
                          props={{
                            onBlur: handleBlur,
                          }}
                        />
                        {touched.phone && errors.phone && (
                          <span style={{ color: "white" }}>{errors.phone}</span>
                        )}
                      </div>

                      <label htmlFor="staticEmail" className="col-sm-2 col-form-label" >
                        Alamat
                      </label>
                      <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                          <TextArea
                              onChange={handleChange}
                              type="text"
                              name="address"
                              id="address"
                              className="form-control"
                              value={values.address}
                              validation={''}
                              props={{
                                onBlur: handleBlur,
                              }}
                            />
                            {touched.address && errors.address && (
                              <span style={{ color: "white" }}>{errors.address}</span>
                            )}
                      </div>

                      <label htmlFor="staticEmail" className="col-sm-2 col-form-label" >
                        Lokasi JPO
                      </label>
                      <div className="col-sm-10" style={{ paddingBottom: "10px" }}>
                        <SelectInput
                          onChange={(e) => {
                            // console.log(e)
                            let event = { target: { name: 'sitesId', value: e.target.value } }
                              setSite(e.target.value)
                              handleChange(event)
                          }}
                          name="sitesId"
                          id="sitesId"
                          value={siteId}
                          option={optionSites}
                          validation={''}
                          props={{
                            onBlur: handleBlur,
                            helperText: touched.sitesId && errors.sitesId,
                            error: Boolean(errors.sitesId && touched.sitesId),
                          }}
                        />
                      </div>
                    </div>
                  </div>
          </form>
        )}
      </Formik>
      {/* <div className="row">
        <div className="col-xl-12">
          <div style={{ width: '100%', marginBottom: '20px' }}>
            <span style={{ fontSize: 'medium', fontWeight: '500', color: 'white' }}>
              Detail User
            </span>
          </div>
            <Formik
              onSubmit={handleFormSubmit}
              initialValues={initialValuesDetail}
              validationSchema={validationSchemaDetail}
            >
              {({ values, errors, touched, handleChange, handleBlur, handleSubmit, }) => (
                <form onSubmit={handleSubmit} id="userDetail-form">
                  
                </form>
              )}
            </Formik>
        </div>
      </div> */}
    </ModalComponent>
  );
};

export default FormUser;
